import { makeStyles } from '@material-ui/core';
import { ThemeInstance } from 'configs/theme';

export const useStyles = makeStyles((theme: ThemeInstance) => ({
  root: {
    display: 'flex',
    height: '100%',
    marginLeft: 20,
  },
  button: {
    minWidth: 'auto',
    padding: 2,
    background: '#fff',
    borderRadius: '50%',
    transition: 'background-color, opacity .15s linear',
    '&:hover': {
      background: '#fff',
      opacity: '.8',
    },
  },
  icon: {
    color: theme.custom.darkBlue,
  },
  iconActive: {
    transform: 'rotate(180deg)',
  },
  elevation1: {
    boxShadow: '0px 3px 6px rgba(0, 0, 0, .29)',
  },
  rounded: {
    borderRadius: 0,
  },
  menuItem: {
    padding: 16,
    fontSize: 15,
    fontFamily: 'NeoSansStd',
    color: theme.custom.darkBlue,
  },
  outputWrapper: {
    display: 'inline-flex',
    alignItems: 'center',
    cursor: 'pointer',
  },
  output: {
    marginRight: 15,
  },
}));
